import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleButtonsComponent } from './toggle-buttons.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [ToggleButtonsComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule],
  exports: [ToggleButtonsComponent],
})
export class ToggleButtonsModule {}
